const StepSummaryConfig = {
  1: {
    text: "I’m evaluating the content on your website to identify the most relevant page for each of the keywords you’ve selected.",
    svg: 'illustrations/ai-onboarding-image-6'
  },
  2: {
    text: "I’m matching your keywords to the most relevant pages.",
    svg: 'illustrations/ai-onboarding-image-6'
  },
  3: {
    text: "I’m selecting up to 3 top keywords for each page.",
    svg: 'illustrations/ai-onboarding-image-6'
  },
  4: {
    text: "I'm grouping keywords which require a new page",
    svg: 'illustrations/ai-onboarding-image-6'
  },
  5: {
    text: "I’m reviewing and finalising the selection of pages based on your keywords.",
    svg: 'illustrations/ai-onboarding-image-6'
  },
};

export {
  StepSummaryConfig,
};
